import React, { useState, useEffect } from "react";
import { useAppDispatch } from "../Core/store.hooks";
import PSTCustomerGridWidget from "./PSTCustomerGridWidget";
import DashboardContainer from "../Common/Components/DashboardContainer";
import Filters from "./Filter";
import { toggleSidebar } from "../Common/Slices/SidebarSlice";
import { AuthApi } from "../Core/api";

const Search = () => {
  const dispatch = useAppDispatch();

  const positionData = [
    { col: 1, colSpan: 6, rowSpan: 12 },
    { col: 1, colSpan: 6, rowSpan: 12 },
  ];
    useEffect(() => {
        AuthApi.logUserEvent("PST Search")

    }, []);
  useEffect(() => {
    dispatch<any>(toggleSidebar({ isOpen: true }));
  }, []);

  const sidebarItems: { title: string; item: any; expanded: boolean }[] = [
    {
      title: "Search Filters",
      item: <Filters gridType="PST" />,
      expanded: true,
    },
  ];
  const getDefaultWidgets = () => {
    return [<PSTCustomerGridWidget header="PST Customer List" id="13" />];
  };
  const defaultWidgets = getDefaultWidgets();

  return (
    <DashboardContainer
      sidebarItems={sidebarItems}
      positionData={positionData}
      defaultWidgets={defaultWidgets}
      addRemove={false}
      savable={false}
    />
  );
};

export default Search;
